// Dynamically load Forte scripts from URLs specified in environment variables
export function loadForteScripts() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.__FORTE_LOADING__) return window.__FORTE_LOADING__;
  if (window.forte) {
    console.log('[ForteScriptLoader] Forte already loaded, skipping.');
    return Promise.resolve();
  }

  const checkoutSrc = process.env.REACT_APP_FORTE_CHECKOUT_URL;
  const apiSrc = process.env.REACT_APP_FORTE_API_URL;

  const host = (typeof window !== 'undefined' && window.location?.hostname) ? window.location.hostname : '';
  const isSandboxHost =
    host.includes('dev') ||
    host.includes('demo') ||
    host.includes('localhost') ||
    host.includes('127.0.0.1');

  const fallbackCheckoutSrc = isSandboxHost
    ? 'https://sandbox.forte.net/checkout/v2/js?nocache=2'
    : 'https://checkout.forte.net/v2/js?nocache=1';
  const fallbackApiSrc = isSandboxHost
    ? 'https://sandbox.forte.net/api/js/v1?nocache=1'
    : 'https://api.forte.net/js/v1?nocache=1';

  const resolvedCheckoutSrc = checkoutSrc || fallbackCheckoutSrc;
  const resolvedApiSrc = apiSrc || fallbackApiSrc;

  if (!checkoutSrc || !apiSrc) {
    console.warn('[ForteScriptLoader] Forte URLs missing in env; using hostname-based defaults.');
    console.warn('  REACT_APP_FORTE_CHECKOUT_URL:', checkoutSrc);
    console.warn('  REACT_APP_FORTE_API_URL:', apiSrc);
    console.warn('  Fallback Checkout URL:', fallbackCheckoutSrc);
    console.warn('  Fallback API URL:', fallbackApiSrc);
  }

  console.log('[ForteScriptLoader] Loading Forte scripts:');
  console.log('  Checkout URL:', resolvedCheckoutSrc);
  console.log('  API URL:', resolvedApiSrc);

  function addScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) return resolve();
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;
      s.onload = () => resolve();
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });
  }

  window.__FORTE_LOADING__ = Promise.resolve()
    .then(() => addScript(resolvedCheckoutSrc))
    .then(() => addScript(resolvedApiSrc))
    .then(() => ({ loaded: true }))
    .catch((e) => {
      console.error('[ForteScriptLoader] Failed to load Forte scripts', { error: e });
      return { loaded: false, reason: 'script-load-failed' };
    });

  return window.__FORTE_LOADING__;
}

// Simplified - just load the scripts from env vars
export function loadForteForCurrentEnv() {
  console.log('[ForteScriptLoader] Loading Forte scripts from environment configuration');
  try {
    return Promise.resolve(loadForteScripts()).catch((e) => {
      console.error('[ForteScriptLoader] Suppressed Forte loader error', e);
      return { loaded: false, reason: 'loader-error' };
    });
  } catch (e) {
    console.error('[ForteScriptLoader] Suppressed sync Forte loader error', e);
    return Promise.resolve({ loaded: false, reason: 'loader-error' });
  }
}
